$(document).ready(function () {
    if ($(".in-index").length) {
        $("#content-wrapper").css("opacity", "1");
    }
})